import React from 'react';
import { useSelector } from 'react-redux';
import { arrayOf, bool, element, shape, string } from 'prop-types';
import cn from 'classnames';

import CustomModal from '~components/CustomModal';
import LottieIcon from '~components/LottieIcon';

import styles from './styles.module.scss';

const ErrorModal = ({ buttons = [], modalName, children, showModal, buttonComponent }) => {
  const open = useSelector((state) => state.modal[`${modalName}ModalIsOpen`]);
  const Button = buttonComponent || 'button';
  return (
    showModal && (
      <CustomModal
        shouldCloseOnOverlayClick={false}
        hideCloseButton
        className={styles.modal}
        modal={modalName}
        isOpen={open}>
        <LottieIcon icon="orderDeclined" loop width={150} height={150} />
        {children}
        {buttons.map(({ className, text, id, ...props }, index) => (
          <Button
            key={id}
            type="button"
            className={cn(className, styles.button, styles[`button-${index}`])}
            {...props}>
            {text}
          </Button>
        ))}
      </CustomModal>
    )
  );
};

ErrorModal.defaultProps = {
  showModal: true
};

ErrorModal.propTypes = {
  buttonComponent: element,
  buttons: arrayOf(shape({})),
  modalName: string,
  showModal: bool
};

export default ErrorModal;
